<template>
  <a v-if="image" class="tile" :href="entry.onlineStoreUrl">
    <div class="tile__gradient">
      <img :src="image" class="tile__image" />
    </div>
    <div class="tile__info">
      <div class="tile__category">{{ entry.tags[0] }}</div>
      <h3 class="tile__heading">{{ entry.title }}</h3>
      <h3 class="tile__text">{{ entry.excerpt }}</h3>
      <div class="tile__link">Read the story</div>
    </div>
  </a>
</template>

<script>
export default {
  name: "JournalTile",
  props: {
    entry: {
      type: Object,
      default: null,
    },
  },
  computed: {
    image() {
      return this.entry.image?.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.tile {
  line-height: 0;
  position: relative;

  &__info {
    bottom: 0;
    color: $color-white;
    left: 0;
    line-height: normal;
    padding: 15px 15px 30px;
    position: absolute;
    right: 0;
    text-align: left;

    @include respond-above(md) {
      padding: 40px;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__gradient {
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: inline-block;
      background: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.75) 0%,
        rgba(0, 0, 0, 0) 30%
      );
    }
  }

  &__heading {
    margin: 0 0 10px 0;
    white-space: normal;
    @include t__editorial-headline-20;

    @include respond-above(md) {
      @include t__editorial-headline-40;
    }
  }

  &__text {
    display: none;
    margin: 0 0 30px 0;
    white-space: normal;
    @include t__editorial-body-20;

    @include respond-above(md) {
      display: block;
    }
  }

  &__category {
    @include t__utility-label-20;
    margin: 0 0 5px 0;
  }

  &__link {
    color: rgba(255, 255, 255);
    text-decoration: none;
    @include t__utility-label-20;
  }
}
</style>
